/**
 * @module modules/common/anomaly
 * @description Anomaly utility functions.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatNumber: function() {
        return formatNumber;
    },
    formatPercentage: function() {
        return formatPercentage;
    },
    getPercentChange: function() {
        return getPercentChange;
    },
    formatBug: function() {
        return formatBug;
    },
    GetEmptyGroupReportRequest: function() {
        return GetEmptyGroupReportRequest;
    }
});
const _lit = require("lit");
const formatNumber = (num)=>num.toLocaleString('en-US', {
        maximumFractionDigits: 4
    });
const formatPercentage = (num)=>num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        signDisplay: 'exceptZero'
    });
const getPercentChange = (median_before, median_after)=>{
    const difference = median_after - median_before;
    // Division by zero is represented by infinity symbol.
    return 100 * difference / median_before;
};
const formatBug = (bugHostUrl, bugId)=>{
    if (bugId === 0) {
        return (0, _lit.html)``;
    }
    if (bugId === -1) {
        return (0, _lit.html)`Invalid Alert`;
    }
    if (bugId === -2) {
        return (0, _lit.html)`Ignored Alert`;
    }
    // Trim the trailing '/' since we are adding it in the format.
    if (bugHostUrl.endsWith('/')) {
        bugHostUrl = bugHostUrl.substring(0, bugHostUrl.length - 1);
    }
    return (0, _lit.html)`<a href="${`${bugHostUrl}/${bugId}`}" target="_blank">${bugId}</a>`;
};
const GetEmptyGroupReportRequest = ()=>({
        anomalyIDs: '',
        rev: '',
        bugID: '',
        anomalyGroupID: '',
        sid: ''
    });
